import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Typography } from 'kangarootime-ui';
import './Message.css';

// props.children should be a component that renders the content of the message
const Message = ({
  avatar,
  sender,
  sentAt,
  sentByCurrentUser,
  attachment,
  ...props
}) => {
  const containerClasses = classnames({
    'sender-message-container': true,
    'sender-message-container-me': sentByCurrentUser
  });

  const bubbleClasses = classnames({
    'sent-by-chat-bubble': true,
    'sent-by-me-bubble': sentByCurrentUser
  });

  return (
    <div className={containerClasses} style={{ alignItems: 'flex-end' }}>
      <img className='senders-avatar' src={avatar} alt='sender' />
      <div className='flex-columns'>
        { attachment }
        { props.children &&
          <div className={bubbleClasses}>
            { props.children }
          </div>
        }
        <Typography
          type='meta'
          style={{
            fontSize: 10,
            lineHeight: 'normal',
            margin: '0 8px',
            alignSelf: sentByCurrentUser ? 'flex-end' : 'flex-start'
          }}
        >{sentAt}</Typography>
      </div>
    </div>
  );
};

Message.propTypes = {
  avatar: PropTypes.string,
  sender: PropTypes.string,
  sentAt: PropTypes.string,
  sentByCurrentUser: PropTypes.bool,
  attachment: PropTypes.object // React component
};

export default Message;
